<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<h2>实名认证</h2>
		</div>
		<div class="ld-panel-main">
			<dl class="auth-success">
				<dt></dt>
				<dd>
					<h4 class="title">恭喜您已通过蓝队云实名认证！</h4>
					<p><span>认证类型：</span>{{authData.authTypeName}}</p>
					<p v-if="authData.authType =='2'"><span>单位名称：</span>{{authData.companyName}}</p>
					<p><span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>{{authData.trueNameEncrypt}}</p>
					<p><span>证件号码：</span>{{authData.IDCardEncrypt}}</p>
					<p><span>手机号码：</span>{{authData.mobileEncrypt}}</p>
					<p><span>认证时间：</span>{{authData.authTime}}</p>
					<h5 v-if="authData.authType !=='2'">如果您想升级为企业认证，可 <el-text type="primary" style="cursor: pointer;" @click="go">重新选择&gt;</el-text></h5>
				</dd>
			</dl>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import sideNav from '../../components/sideNav.vue';
	import { authInfo } from '@/api/auth';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	const authData =ref('');
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus !== '1') {
					router.push({ path: '/verify' })
				}else{
					authData.value = res.data;
					showFlag.value = true;
				}
			}
		})
	};
	const go = () => {
		if (authData.value.businessStatus == '2') {
			router.push({ path: '/verify/audit' })
		}else if(authData.value.businessStatus == '3'){
			router.push({ path: '/verify/businessinfo' })
		}else if(authData.value.businessStatus == '4'){
			router.push({ path: '/verify/check' })
		}else{
			router.push({ path: '/verify/business' })
		}
	}
	
	onMounted(() => {
		generData()
	})
	

</script>

<style lang="scss" scoped>
	.auth-success{
		border: 1px solid #eee;
		padding: 40px 0 50px;
		overflow:hidden;
		dt{ width:30%; height:200px; float:left;background:url(../../assets/images/auth_icon_success.png) right 50px no-repeat;  overflow:hidden;}
		dd{ 
			width:66%; 
			float:right; 
			overflow:hidden;
			p{
				font-size: 12px; 
				color: #666; 
				margin:0 0 10px;
				span{ color:#a0a2a3;}
			}
			h5{ margin:30px 0 0; color:#a0a2a3;}
			.btn{background-color: #fff !important;color: #015BFE !important;}
			.title{margin-bottom: 30px; text-align: left; font-weight: bold;font-size: 22px;color: #262829;}
		}
	}
</style>